import './Ticket.scss';
import Button from "react-bootstrap/Button";
import React from "react";
import {Badge} from "react-bootstrap";
import {useNavigate, useInRouterContext} from "react-router-dom";

const TicketComponent = ({ticket, onClick}) => {
    // const inRouter = useInRouterContext();
    // const navigate =  useNavigate() ;

    function handleClick(advantages = false) {
        if (typeof onClick === "function")
            onClick(advantages);
        // } else if(inRouter) {
        //     navigate("/buy/" + ticket.id + (advantages ? "?advantage=true" : ""))
        // }
    }
let area = ticket.area;
    let image = ticket.image;
    if (image === null)
        image = ticket.area.image;
    image = global.baseUrl + encodeURI(image);
    let type = ticket.type;

    switch (ticket.type) {
        case "HOURLY":
            type = "Orario";
            break;
        case "DAILY":
            type = "Giornaliero";
            break;
        case "TWODAYS":
            type = "Bigiornaliero";
            break;
        case "THREEDAYS":
            type = "Tre giorni";
            break;
        case "FOURDAYS":
            type = "Quattro giorni";
            break;
        case "WEEKDAYS":
            type = "Cinque giorni";
            break;
        case "WEEKLY":
            type = "Settimanale";
            break;
        case "TWOWEEKS":
            type = "Bisettimanale";
            break;
        case "MONTHLY":
            type = "Mensile";
            break;
        case "TRIMESTER":
            type = "Trimestrale";
            break;
        case "SEASONAL":
            type = "Stagionale";
            break;
        case "SEMIANNUAL":
            type = "Semestrale";
            break;
        case "YEARLY":
            type = "Annuale";
            break;
        case "BIANNUAL":
            type = "Biennale";
            break;
        case "TRIENNIAL":
            type = "Triennale";
            break;
    }

    let second_btn = null;
    if(area.category.type === "TYPE_MUSHROOM")
        second_btn = <Button variant="light" onClick={() => handleClick(true)}>Usa con la
            tabella intelligente</Button>
    return (
        <div className="ticket-container">
            <div className="ticket-image"
                 style={{backgroundImage: `url(${image})`}}
            >
                <span>{ticket.name}</span>
                <div style={{
                    position: "absolute",
                    bottom: 4,
                    left: 4,
                    right: 4,
                    zIndex: 10,
                    gap: 10,
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    display: 'flex',
                    overflow: 'hidden'
                }}>
                    <Badge bg="light">{type}</Badge>
                    {/*<Badge bg="success">{ticket.ticket_residence_type.name}</Badge>*/}
                </div>
            </div>
            <div className={`ticket-body`}>
                <span>{ticket.ticket_residence_type.name}</span>
                <span>{ticket.date_start_validity} - {ticket.date_end_validity}</span>
                <span>{ticket.price.toFixed(2)}€</span>

            </div>
            <div className="ticket-footer">
                <Button variant="success" onClick={() => handleClick()}>Acquista ticket</Button>
                {second_btn}
            </div>
        </div>
    );
};

export default TicketComponent;
